import React, { useEffect } from 'react'
import { useState } from 'react'
import './EmailPreviewSection.scss'
import previewIcon from './previewIcon.png'
import { Button } from 'antd'
import { API_ENDPOINT_TEMPLATE } from '../vendorfollowup.constants'



const EmailPreviewSection = () => {
    const [selectedTemplate, setSelectedTemplate] = useState("d-744bd0419cf54c3cac21b81b4731e0cb");
    const [emailBody, setEmailBody] = useState(null);
    const [emailSubject, setEmailSubject] = useState("Mandatory E-Invoicing Compliance Under GST- Vendor Wise")
    const templates = [
        { id: "d-744bd0419cf54c3cac21b81b4731e0cb",name:"Mandatory E-Invoicing Compliance Under GST- Vendor Wise", label: "Mandatory E-Invoicing template", day: " " },
        { id: "d-315b0365c9754a5dbb97449e653f06a1", name:"Invoice-Wise Follow-Up 1 (Immediate Notification)",label: "Follow-up 1 template", day: " " },
        { id: "d-cd77675790a943be9b6a834848ca3522", name:"Invoice-Wise Follow-Up 2 (General Reminder)",label: "Follow-up 2 template", day: " " },
        { id: "d-28efe496b27c4943848567ace11566a3",name:"Invoice-Wise Follow-Up 3 (Final Warning via GST Portal)", label: "Follow-up 3 template", day: " " },
        { id: "d-cd5ac40badac430eb34d4f3ac6510908", name:"Follow-Up Reminder to Generate E-Invoice",label: "Follow-Up Reminder template", day: " " },
        { id: "d-01123bf8287349de9dbdbfcf0389873d", name:"Final Warning from GST Portal",label: "Final Warning template", day: " " },
        { id: "d-6da054d0dac0491b96987609d8e0093f", name:"E-Invoice Acknowledgement",label: "E-Invoice Acknowledgement template", day: " " },
    ];

  

    //----new----//
    const selectedTemplateData = templates.find(
        (template) => template.id === selectedTemplate
    );

    const handleTemplateClick = async (templateId, templateName) => {
        setSelectedTemplate(templateId);
        setEmailSubject(templateName)
        await fetchTemplateContent(templateId);
    };
    const fetchTemplateContent = async (templateId) => {
        try {
            const response = await fetch(`${API_ENDPOINT_TEMPLATE}${templateId}`);
            const data = await response.json();

            if (data.plain_content) {
                const bodyContent = data.plain_content
                    .replace(/\*/g, '')
                    .replace(/Subject:.*(\r?\n)+/, '')
                    .trim();

                const populatedBody = bodyContent
                    .replace('{{vendor_name}}', 'Vendor')
                    .replace('{{invoice_number}}', 'xxxx')
                    .replace('{{invoice_date}}', 'xxxx')
                    .replace('{{your_name}}', "Name")
                    .replace('{{your_position}}', "Position")
                    .replace('{{your_contact_information}}', "Contact Info");

                setEmailBody(populatedBody);


            } else {
                console.error("Failed to load template content");
            }
        } catch (error) {
            console.error("Error fetching template content:", error);
        }
    };


    console.log(emailSubject, "emailSubject")
    useEffect(() => {

        fetchTemplateContent(selectedTemplate);
    }, []);

    const goToNextTemplate = () => {
        const currentIndex = templates.findIndex(t => t.id === selectedTemplate);
        if (currentIndex < templates.length - 1) {
          const nextTemplate = templates[currentIndex + 1];
          handleTemplateClick(nextTemplate.id, nextTemplate.name);
        }
      };

    return (
        <div style={{display:'flex',flex:1}}>
            <div className='EmailSection'>


                <div style={{ display: "flex" }}>
                    <div className="EmailSection-Stepper">
                        {templates.map((template, index) => (
                            <React.Fragment key={index}>
                                <div
                                    className={`followUpItem ${selectedTemplate === template.id ? "followUp1" : "defaultFollowUp"
                                        }`}
                                    onClick={() => handleTemplateClick(template.id, template.name)}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', gap: '12px' }}>
                                            <div
                                                className={`circleNumber ${selectedTemplate === template.id ? "activeBorder" : "inactiveBorder"
                                                    }`}
                                            >
                                                {index + 1}
                                            </div>
                                            <div
                                                className={`followUpText ${selectedTemplate === template.id ? "activeText" : "inactiveText"
                                                    }`}
                                            >
                                                {template.label}
                                            </div>
                                        </div>


                                        <div className="followUpContent">
                                            <div
                                                className={`followUpDay ${selectedTemplate === template.id ? "activeText" : "inactiveText"
                                                    }`}
                                            >
                                                {template.day}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {index < templates.length - 1 && (
                                    // <div className="arrowIcon">{">>"}</div>
                                    <div className="arrowIcon" onClick={goToNextTemplate} style={{ cursor: 'pointer' }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.51192 4.43057C6.82641 4.161 7.29989 4.19743 7.56946 4.51192L13.5695 11.5119C13.8102 11.7928 13.8102 12.2072 13.5695 12.4881L7.56946 19.4881C7.29989 19.8026 6.82641 19.839 6.51192 19.5695C6.19743 19.2999 6.161 18.8264 6.43057 18.5119L12.0122 12L6.43057 5.48811C6.161 5.17361 6.19743 4.70014 6.51192 4.43057ZM10.5121 4.43068C10.8266 4.16111 11.3001 4.19753 11.5697 4.51202L17.5697 11.512C17.8104 11.7929 17.8104 12.2073 17.5697 12.4882L11.5697 19.4882C11.3001 19.8027 10.8266 19.8391 10.5121 19.5696C10.1976 19.3 10.1612 18.8265 10.4308 18.512L16.0124 12.0001L10.4308 5.48821C10.1612 5.17372 10.1976 4.70024 10.5121 4.43068Z" fill="#0A8394" />
                                        </svg>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className='EmailPreviewHeadingSection'>
                    <div style={{ display: "flex", gap: "12px" }}>
                        <img src={previewIcon} className='previewImage' />
                        <div>
                            {/* <p className='previewText'>Preview of follow-up 1 template</p> */}
                            <p className='previewText'>
                                {selectedTemplateData
                                    ? `Preview of ${selectedTemplateData.label}`
                                    : "Select a template to preview"}
                            </p>
                            <p className='visualText'>This is visual idea how the mail would look like</p>
                        </div>
                    </div>
                    <div className='emailBody'>
                        <div className='emailHeader'>
                            <div className='emailTo' style={{ display: "flex", gap: "60px", padding: "8px 0px 8px 16px", alignItems: 'end', borderBottom: "1px solid rgba(232, 234, 241, 1)" }}>
                                <div className='emailTextTo'>
                                    To
                                </div>
                                <div className='vendorDetails'>
                                    Vendor_01
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.25 4.66667L8.75 9.33333M8.75 4.66667L5.25 9.33333M7 12.25C8.39239 12.25 9.72774 11.6969 10.7123 10.7123C11.6969 9.72774 12.25 8.39239 12.25 7C12.25 5.60761 11.6969 4.27226 10.7123 3.28769C9.72774 2.30312 8.39239 1.75 7 1.75C5.60761 1.75 4.27226 2.30312 3.28769 3.28769C2.30312 4.27226 1.75 5.60761 1.75 7C1.75 8.39239 2.30312 9.72774 3.28769 10.7123C4.27226 11.6969 5.60761 12.25 7 12.25Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>


                        <div className='emailHeader'>
                            <div className='emailTo' style={{ display: "flex", gap: "60px", padding: "8px 0px 8px 16px", alignItems: 'end', borderBottom: "1px solid rgba(232, 234, 241, 1)" }}>
                                <div className='emailTextTo'>
                                    CC
                                </div>
                                <div className='vendorDetailsCC'>
                                    example.com
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.25 4.66667L8.75 9.33333M8.75 4.66667L5.25 9.33333M7 12.25C8.39239 12.25 9.72774 11.6969 10.7123 10.7123C11.6969 9.72774 12.25 8.39239 12.25 7C12.25 5.60761 11.6969 4.27226 10.7123 3.28769C9.72774 2.30312 8.39239 1.75 7 1.75C5.60761 1.75 4.27226 2.30312 3.28769 3.28769C2.30312 4.27226 1.75 5.60761 1.75 7C1.75 8.39239 2.30312 9.72774 3.28769 10.7123C4.27226 11.6969 5.60761 12.25 7 12.25Z" stroke="#2355D2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className='subjectHeader'>
                            <div className='subject' style={{ display: "flex", gap: "35px", padding: "8px 0px 8px 16px", alignItems: 'end', borderBottom: "1px solid rgba(232, 234, 241, 1)" }}>
                                <div className='subjectTo'>
                                    Subject
                                </div>
                                <div className='subjectDetail'>
                                    {emailSubject}
                                </div>
                            </div>
                        </div>
                        <div className="email-body-container" style={{flex:1}}>
                            <textarea
                                className="email-body1"
                                value={emailBody}
                                readOnly
                                onChange={(e) => setEmailBody(e.target.value)}
                                placeholder="Write your message here..."
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default EmailPreviewSection
